/**
 * TtsVoicePicker — пилюля «Голос» озвучки В ВИДЖЕТЕ (десктоп).
 *
 * Голосов сотни (библиотека ElevenLabs по языку и сценарию), поэтому пилюля
 * открывает окно VoicePickerSheet, а не выпадашку. Подпись — имя выбранного
 * голоса (settings.audioVoiceName); ничего не выбрано или id устарел (Mureka) —
 * стандартный голос по умолчанию. Мобильная версия — VoiceRow в MobileSettingsSheet.
 */
import { useState } from 'react'
import { Icon } from '../../../../public/icons/Icon.tsx'
import { useVoiceLabel, type TtsVoice } from '../utils/ttsVoices'
import VoicePickerSheet from './VoicePickerSheet'

interface Props {
	currentVoice: string | undefined
	currentVoiceName?: string
	onApply: (voice: TtsVoice) => void
	disabled?: boolean
}

export default function TtsVoicePicker({ currentVoice, currentVoiceName, onApply, disabled }: Props) {
	const [open, setOpen] = useState(false)
	const label = useVoiceLabel(currentVoice, currentVoiceName)

	return (
		<div className="wmp tts-voice">
			<button
				type="button"
				className="wmp__pill"
				onClick={() => setOpen(true)}
				disabled={disabled}
				aria-label={`Голос: ${label}`}
			>
				<Icon id="gen-audio" size={15} />
				<span className="wmp__pill-label">{label}</span>
				<svg className="wmp__pill-chevron" width="10" height="10" viewBox="0 0 10 10" fill="none" aria-hidden="true">
					<path d="M2 3.5L5 6.5L8 3.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
				</svg>
			</button>
			<VoicePickerSheet
				open={open}
				onClose={() => setOpen(false)}
				currentVoiceId={currentVoice}
				onSelect={onApply}
			/>
		</div>
	)
}
